<template>
  <div class="block-special-appraisal" :style="styles">
    <h3><img src="/static/img/recommend/lp/houen/products/head_special_apprisal.png" alt="特別鑑定"></h3>
    <div class="special-appraisal-box">
      <div
        class="group-block"
        v-for="(grp, gidx) in appraisalList"
        :key="gidx"
        :class="{[`grp-${gidx}`]:true}"
      >
        <h4>{{grp.title}}</h4>
        <img :src="grp.image" alt="">
        <div
          v-for="(item, idx) in grp.list"
          :key="idx"
          class="list-item"
          :class="{new: +item.is_new > 0}"
        >
          <span class="title" @click="onListItemClick(item.url)">{{item.title}}</span>
        </div>
      </div>
      <img src="/static/img/recommend/lp/houen/products/line_paperbottom.svg" alt="" class="endline"> 
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'BlockSpecialAppraisal',
  props: {
    appraisalList: {
      type: Array,
      required: true,
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  },
  methods: {
    onListItemClick(url) {
      location.href = this.$handoverParams(url)
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.block-special-appraisal {
  .group-block {
    .list-item {
      padding: 20px 0;
      border-bottom: 1px solid #dadada;
      position: relative;
      &:last-child{
        border: none;
      }
      &:after{
        position: absolute;
        height: 16px;
        top: 27px;
        right: 0;
        content: '';
        background: url(/static/img/recommend/lp/houen/products/ic_arrow.svg) no-repeat;
        width: 9px;
      }
      .title {
        display: block;
        cursor: pointer;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #32373f;
        @include mq('w580'){
          font-size: 16px;
        }
      }
      &.new {
        .title {
          display: flex;
          align-items: center;
          max-width: 90%;
          &::after {
            content: "NEW";
            color: $l_col_keycolor;
            background: #eded67;
            font-weight: 600;
            font-size: 10px;
            line-height: 10px;
            padding: 3px;
            margin-left: 6px;

          }
        }
      }
    }
  }
  .special-appraisal-box{
    background: #fff;
    padding-top: 24px;
    margin-bottom: 60px;
    position: relative;
    padding-bottom: 60px;
  }
  h3{
    margin: 0;
  }
  h4{
    margin: 0;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    color: $l_col_keycolor;
    text-align: center;
    margin-bottom: 12px;
  }
  .group-block{
    border: 10px solid #eded67;
    border-radius: 10px;
    margin: 0 20px 16px;
    padding: 16px;
    padding-bottom: 0;
  }
  .endline{
    width: 100%;
    position: absolute;
    bottom: -10px;
  }

}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockSpecialAppraisal.vue